import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/questions";
import { COMPANY_INFO } from "@/lib/company";

export default function Header({ variant = "public" }) {
  const { user, logout, isAdmin } = useAuth();

  return (
    <header className="tm-header sticky top-0 z-40" data-testid="site-header">
      {/* Riga superiore con anagrafica aziendale */}
      <div className="border-b border-slate-800/70 bg-slate-950/60">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-1.5 flex flex-wrap items-center justify-between gap-x-4 gap-y-1 text-xs font-mono text-slate-400">
          <div className="hidden sm:block" data-testid="header-company-legal">
            <span className="text-slate-200">{COMPANY_INFO.legal}</span>
            <span className="text-slate-600 mx-2">·</span>
            <span data-testid="header-company-address">{COMPANY_INFO.address}</span>
          </div>
          <div className="flex items-center gap-3 w-full sm:w-auto justify-between sm:justify-start">
            <a href={`tel:${COMPANY_INFO.phoneTel}`} className="hover:text-orange-400 transition-colors" data-testid="header-company-phone">
              tel. {COMPANY_INFO.phone}
            </a>
            <span className="text-slate-700">|</span>
            <a href={`mailto:${COMPANY_INFO.email}`} className="hover:text-orange-400 transition-colors" data-testid="header-company-email">
              {COMPANY_INFO.email}
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2 sm:py-3 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-3 group" data-testid="logo-link">
          <img
            src={LOGO_URL}
            alt="TOP-TEC"
            className="h-8 sm:h-10 md:h-12 tm-logo"
            data-testid="logo-image"
          />
          <div className="hidden sm:block border-l border-slate-700 pl-3">
            <div className="font-mono text-[10px] uppercase tracking-widest text-slate-400">
              Product Finder B2B
            </div>
          </div>
        </Link>

        <nav className="flex items-center gap-3">
          {isAdmin && variant === "public" && (
            <Link to="/admin" className="tm-btn-outline text-sm !px-3 sm:!px-6" data-testid="admin-link">
              <span className="sm:hidden">Admin</span>
              <span className="hidden sm:inline">Dashboard Admin</span>
            </Link>
          )}
          {user && (
            <>
              <span className="hidden md:inline text-xs text-slate-400 font-mono" data-testid="user-email">
                {user.email} · <span className="text-orange-500">{user.role === "agent" ? "agente" : user.role}</span>
              </span>
              <button
                onClick={logout}
                className="tm-btn-outline text-sm"
                data-testid="logout-btn"
              >
                Esci
              </button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
